module.exports = "/img/banner.150626f7.png";